
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as edoQh8goBzTaqv3XJ9QnfwIU8SPSuTEMX2BCTdqHTU2r2kMeta } from "/var/www/2025-07-16_14_46/pages/edo.vue?macro=true";
import { default as helpQ4VWDyu4PXj5Uy0ulU_qSdYtEXZDsIu1_jnYewK5hMwMeta } from "/var/www/2025-07-16_14_46/pages/help.vue?macro=true";
import { default as cargoJ5UiJzbAyAdGL0Q7yYhDScyR9ql94p6ZUzdjxg8nL5sMeta } from "/var/www/2025-07-16_14_46/pages/cargo.vue?macro=true";
import { default as index8gNuDbta4elorNNLC_451i09ecBXVytdMuferZyGLMjv0Meta } from "/var/www/2025-07-16_14_46/pages/index.vue?macro=true";
import { default as _91slug_93a7ZDgwtdYXEmYNgE6fbkrnwLmoOIUJg6bVDldfASBh8Meta } from "/var/www/2025-07-16_14_46/pages/[slug].vue?macro=true";
import { default as cookiei5IvJ_P6cku3ecHGsF1olhk6axhfT1s7tNhqxCbBpM0Meta } from "/var/www/2025-07-16_14_46/pages/cookie.vue?macro=true";
import { default as surveyqXk_59xgngMqMYHadawrAYLzAhS_JhzZ_oKUjazNN84Meta } from "/var/www/2025-07-16_14_46/pages/survey.vue?macro=true";
import { default as belarusMGAIEdlFWbLg9S5p5YiFtKc_45Kc9hjUEeQxaEN362oKUMeta } from "/var/www/2025-07-16_14_46/pages/belarus.vue?macro=true";
import { default as bonuseszBMa_45SWzpO9zo_45nyDHKOvh5WCYuZodzYqZIvBiuJbp8Meta } from "/var/www/2025-07-16_14_46/pages/bonuses.vue?macro=true";
import { default as api9_yoniD6cx4J123U0IMenYuCfBq6f13Og0uv6UnScwgMeta } from "/var/www/2025-07-16_14_46/pages/dev/api.vue?macro=true";
import { default as cms_5pMxyvQobmxj1FoUle8Zg_45nc1PlXbiQ_L8OeANsoyoMeta } from "/var/www/2025-07-16_14_46/pages/dev/cms.vue?macro=true";
import { default as konkurscLlAKBnPegeq5C6MlCtQYNa_tPcDArmgeSeHrcgW7NIMeta } from "/var/www/2025-07-16_14_46/pages/konkurs.vue?macro=true";
import { default as successiSm8I_ChyracHclNnSnmaz2ZnXwrxfIf95hrhrCk_45HQMeta } from "/var/www/2025-07-16_14_46/pages/success.vue?macro=true";
import { default as vacancyooJjc59x_5_453zvJmes8ptogudpcFq7OjwYH_45Cr09QNwMeta } from "/var/www/2025-07-16_14_46/pages/vacancy.vue?macro=true";
import { default as contactsAnx_cR_45rlvpIEGtDLgf7ElEvTADkiXkmwKlIe09oBs0Meta } from "/var/www/2025-07-16_14_46/pages/contacts.vue?macro=true";
import { default as giveawaykM29lutr7UbwS64vsarpCCJ0lCWzmK8_YYATPU_WQO4Meta } from "/var/www/2025-07-16_14_46/pages/giveaway.vue?macro=true";
import { default as guide_45lkSTR8p8JwshtXr6Fse4MKT5ffCXsMO16DnkDcfxzg7QsMeta } from "/var/www/2025-07-16_14_46/pages/guide-lk.vue?macro=true";
import { default as servicesi0AKKHdejSDsUISKe49iIfnWF1pPeN74HaN4tPcZQLMMeta } from "/var/www/2025-07-16_14_46/pages/services.vue?macro=true";
import { default as telegramSsKg3Rh7c98wIHmiSW5oc_45f1xrDSKqwhGQ92EsLdttEMeta } from "/var/www/2025-07-16_14_46/pages/telegram.vue?macro=true";
import { default as documentsRns0Nae5mBBBDOLNV8KOwsSV_dEm6vGnAV5uXR9JXL8Meta } from "/var/www/2025-07-16_14_46/pages/documents.vue?macro=true";
import { default as franchise7_tj3YWulvQUaDGkDsJF3wnZB_Fps2WQ6OFhRzBK7HYMeta } from "/var/www/2025-07-16_14_46/pages/franchise.vue?macro=true";
import { default as insurance0fZp2wEuduvHcg_YnS1v7GOOz9hJvQ6tWLSlx_45u95DMMeta } from "/var/www/2025-07-16_14_46/pages/insurance.vue?macro=true";
import { default as kirghiziant5vTEkoRs5tfHVQOtJnMg_IxElha4iPmjEYvrmHPJoMeta } from "/var/www/2025-07-16_14_46/pages/kirghizia.vue?macro=true";
import { default as mapSchememYY5Xcs9PcBijsD8MAr1vVEL_45c4VsDb3aeDRecMyQmgMeta } from "/var/www/2025-07-16_14_46/pages/mapScheme.vue?macro=true";
import { default as _91id_93Cz_5Vj9TBDboBQCIbe_450JpRQs4XzbqPKsVzJOMuiqQcMeta } from "/var/www/2025-07-16_14_46/pages/news/[id].vue?macro=true";
import { default as return_45sdY8LCtb9dy0sZ4FyMVjVJKrL_4596sCO2uQa8ikhrhZQr4Meta } from "/var/www/2025-07-16_14_46/pages/return-sd.vue?macro=true";
import { default as smsClientPPShBnhmm30rvRkmMpDuf37wA23zwbyv1baTxPU70z0Meta } from "/var/www/2025-07-16_14_46/pages/smsClient.vue?macro=true";
import { default as terminalsyk_45VeOkCW_45OQ5v_iShzap4qVqLwZOXxk_45uy0Gf5Gg90Meta } from "/var/www/2025-07-16_14_46/pages/terminals.vue?macro=true";
import { default as iframeQShsV8NduRyQcTJAYHsRf7UT3_A3gLiS05LXY8Wm21wMeta } from "/var/www/2025-07-16_14_46/pages/dev/iframe.vue?macro=true";
import { default as directionsTb9mFDuLo3LCZfRhkXQlrlisvqC6JNoeGVzz0wi5oVEMeta } from "/var/www/2025-07-16_14_46/pages/directions.vue?macro=true";
import { default as kazakhstanmyL8y88l3LHYlyjlGuDCWYBjCWvl4hSIAsejcFH8ZhoMeta } from "/var/www/2025-07-16_14_46/pages/kazakhstan.vue?macro=true";
import { default as indexqw_45kTrAu91kADWZhniKn6k7PbQsRNaLJQl9lCepvRnoMeta } from "/var/www/2025-07-16_14_46/pages/news/index.vue?macro=true";
import { default as svgxn_FelHnELoP1mfgSuDEh58hnViQuaqk6t3d_nCbI_450Meta } from "/var/www/2025-07-16_14_46/pages/ui-kit/svg.vue?macro=true";
import { default as vzpay_45failwrA_45JWlxcfyNmMcuiE3B12H2wyX7_45eAwWM0W6YF5cEMMeta } from "/var/www/2025-07-16_14_46/pages/vzpay-fail.vue?macro=true";
import { default as constructormkkTDwrpmMi65C_45QsJp9TomqwOZirHdCMENM1U8j1zgMeta } from "/var/www/2025-07-16_14_46/pages/constructor.vue?macro=true";
import { default as indexJBMeZsKX8Xx4qbzB9KW5pCMgFnIEU5hAq1isHWiB8c4Meta } from "/var/www/2025-07-16_14_46/pages/gifts/index.vue?macro=true";
import { default as information3VXRkOywHkz9r71mhxGdrpBS34x_45asJNPLiUUU98tWwMeta } from "/var/www/2025-07-16_14_46/pages/information.vue?macro=true";
import { default as lightFVcpJPMTipij_45Iyz2aKahc9NKOcL2_kJYL0rj7_R9UMMeta } from "/var/www/2025-07-16_14_46/pages/order/light.vue?macro=true";
import { default as claim_45filingXugfmzJ8q4576gR8JQXgPL_45k6OiuZOcywRVotgesQpEMeta } from "/var/www/2025-07-16_14_46/pages/claim-filing.vue?macro=true";
import { default as _91type_93q6cIFPkxbrGfsfJcYGzUId_45zO4e29nOiGCmrlKNha9oMeta } from "/var/www/2025-07-16_14_46/pages/gifts/[type].vue?macro=true";
import { default as marketplacesLn5svzmnkEjoUpqwfOKZC0wlwjGhfDnClry4ysrty_cMeta } from "/var/www/2025-07-16_14_46/pages/marketplaces.vue?macro=true";
import { default as networkshopsh4pIEZmuWePzfxmLtRIlYslu1T8NLsTmH88scAfridYMeta } from "/var/www/2025-07-16_14_46/pages/networkshops.vue?macro=true";
import { default as online_45storeusMpAfkt_bsxjaEFIfrK0F3_c9mmA56soki63lkBYr8Meta } from "/var/www/2025-07-16_14_46/pages/online-store.vue?macro=true";
import { default as managepqcJKTpvNihYtHUgfYrJGfS_IYh2DEagelYZm0xIq1AMeta } from "/var/www/2025-07-16_14_46/pages/order/manage.vue?macro=true";
import { default as registrationY2Bg15SgSjce8tJ0YJcN4Z56WtsZbTlE1BzIi3QDDT4Meta } from "/var/www/2025-07-16_14_46/pages/registration.vue?macro=true";
import { default as safe_45custodyxg5cFFqytq4POBoPEl4IavsYLYIyq9jKVH_DtiXIp9IMeta } from "/var/www/2025-07-16_14_46/pages/safe-custody.vue?macro=true";
import { default as imageVs5q1GENbZmKmaQ8C3QWgkjQibbSg7Ky_45BCkSbw6FX4Meta } from "/var/www/2025-07-16_14_46/pages/ui-kit/image.vue?macro=true";
import { default as index9O9iY5awlJDWcHjR521ixOV_451aKUYVnBPJ1_45J1JnZYYMeta } from "/var/www/2025-07-16_14_46/pages/ui-kit/index.vue?macro=true";
import { default as bagfoEf0YNP3DCqDNRWyqURQP2FtN701gZ59TVkLfDgVNcMeta } from "/var/www/2025-07-16_14_46/pages/wrapping/bag.vue?macro=true";
import { default as boxjFxndCJfTYzboLkWISinyA1Xk1RltD_GVPKtZVAjKIoMeta } from "/var/www/2025-07-16_14_46/pages/wrapping/box.vue?macro=true";
import { default as cargo_45loadingUoDsqfsvlFaIiisJ61XTIKajuF5XLyug1Zq1QXIvs8sMeta } from "/var/www/2025-07-16_14_46/pages/cargo-loading.vue?macro=true";
import { default as happybirthdaypv0kUk1UDdXSS_tWHG2Df19eyB8N4ozofk_od43gEE4Meta } from "/var/www/2025-07-16_14_46/pages/happybirthday.vue?macro=true";
import { default as manageYZnHhiXg_45I_M9Lgbwj8bhUzZN4WZvmBkNPeS75x8pxQMeta } from "/var/www/2025-07-16_14_46/pages/iframe/manage.vue?macro=true";
import { default as authE_45jax25lhRIZTvxreoJUWpm7RxqIuH_45TeKaadIS13U4Meta } from "/var/www/2025-07-16_14_46/pages/personal/auth.vue?macro=true";
import { default as indexbscgUsERolIpBMBkX5sAeQnMnimrY92lzQRZIcmpAuIMeta } from "/var/www/2025-07-16_14_46/pages/tariffs/index.vue?macro=true";
import { default as publicbxkzEKPLswhMLMc1Jr47sUmP_45d6wLUKfFvN_lgHHwNoMeta } from "/var/www/2025-07-16_14_46/pages/ui-kit/public.vue?macro=true";
import { default as already_45answero9RC_45AI2Mj1n96EDAiMwtwywE19UhYRqvvYXQA0CiccMeta } from "/var/www/2025-07-16_14_46/pages/already-answer.vue?macro=true";
import { default as tariffsPiTVDtglUouYcwcK_M_45Nsdi_45IPpZfpZUJu1Re4v7_45T8Meta } from "/var/www/2025-07-16_14_46/pages/iframe/tariffs.vue?macro=true";
import { default as _91id_93wyAqj9J1wABqrMhB2NRw0IpnJDtK0OINGl1AlsXDcY8Meta } from "/var/www/2025-07-16_14_46/pages/order/pay/[id].vue?macro=true";
import { default as indexoJc7qteZzE1PQjib0Mb7C_GrLUBeDSVLMqAZxjQjsTgMeta } from "/var/www/2025-07-16_14_46/pages/personal/index.vue?macro=true";
import { default as privacy_45policyi7vfLnxIuDsP5bCih2Ze5A1l_CnhvX9Hxag_45DNqWyowMeta } from "/var/www/2025-07-16_14_46/pages/privacy-policy.vue?macro=true";
import { default as _91hash_93C4PUphzRZ1sFNN2duuSrYaArFUosbsA4NxWkxlLSkw8Meta } from "/var/www/2025-07-16_14_46/pages/welcome/[hash].vue?macro=true";
import { default as index1JX7qz_aZzwPiN0JGTFhEDggM8zdMlX3C1tTL2F5ozkMeta } from "/var/www/2025-07-16_14_46/pages/wrapping/index.vue?macro=true";
import { default as delivery_45russiaqD1YIZd_TvauNVi8QDrrOe6x_UxQwmf347GpO7t15fwMeta } from "/var/www/2025-07-16_14_46/pages/delivery-russia.vue?macro=true";
import { default as payment_45methods0SyUM_45gqlSFnCx33k_XCgb8BYACHDOQUSVzb77_oI34Meta } from "/var/www/2025-07-16_14_46/pages/payment-methods.vue?macro=true";
import { default as qr_45infogwab3ZCC_Xz_45LVs0P9phi46f9GqMLGoHZVysSqpzvjYMeta } from "/var/www/2025-07-16_14_46/pages/payment/qr-info.vue?macro=true";
import { default as success_45FIDITOAzB4jCaP1VMX92Ve2w_45GZsA4Jid5DmpVw5osMeta } from "/var/www/2025-07-16_14_46/pages/payment/success.vue?macro=true";
import { default as importR6GQ84DnRzJ9XpP8rn0RWvitNjXJNDh0mdVprKtBkswMeta } from "/var/www/2025-07-16_14_46/pages/personal/import.vue?macro=true";
import { default as logoutG0ClCEb2kEdseV0SIouGtOEJW6k1zPTbpFlZmCoBbzIMeta } from "/var/www/2025-07-16_14_46/pages/personal/logout.vue?macro=true";
import { default as address_45deliveryJ1JW9Bxxt4aqsdbjqOXYzQhxiIni0Gc7Bw9izWlJCC0Meta } from "/var/www/2025-07-16_14_46/pages/address-delivery.vue?macro=true";
import { default as cash_45on_45delivery7WmUzid2gYbQ9PI6kGUUEDzvL1ZoOii9gbypX_JQlIIMeta } from "/var/www/2025-07-16_14_46/pages/cash-on-delivery.vue?macro=true";
import { default as happynewyear2024NAEGn9bwkU9sbmHSQ1LW1ukzhHVAoHEbiqyr7XxWQ0MMeta } from "/var/www/2025-07-16_14_46/pages/happynewyear2024.vue?macro=true";
import { default as ozonWfRhJd_6mOVCGsBpBVAL18yv7iBSe9hn6nABRktL5IAMeta } from "/var/www/2025-07-16_14_46/pages/marketplace/ozon.vue?macro=true";
import { default as pay_45failk1IqZmhLftSkcvUMPMn3bTX6JHrBpWQoGvumOVPugGUMeta } from "/var/www/2025-07-16_14_46/pages/payment/pay-fail.vue?macro=true";
import { default as account_K_45MYpfp8s95qL1n2NObaQVGByh0w61BGCpuNyU39SAMeta } from "/var/www/2025-07-16_14_46/pages/personal/account.vue?macro=true";
import { default as prohibited_45goodsoTkIpODIs5gu1V3eX5yGcipSUxL6E7WL5XDQPSUSbZEMeta } from "/var/www/2025-07-16_14_46/pages/prohibited-goods.vue?macro=true";
import { default as survey_45completedNOOcZXPJUJIqGhFx8GdP31rW0uOjKk2vof6bhU1gwQIMeta } from "/var/www/2025-07-16_14_46/pages/survey-completed.vue?macro=true";
import { default as directionVYuSES14FdTrlr7Y_45lQ6l3Ty8Bys8ovWnltSA8snSG0Meta } from "/var/www/2025-07-16_14_46/pages/ui-kit/direction.vue?macro=true";
import { default as free_45group_45pickupVQH6yR1r68Nx1yLZvXdNyM0napOlzvE4cqN1xB0WXIEMeta } from "/var/www/2025-07-16_14_46/pages/free-group-pickup.vue?macro=true";
import { default as free_45pickup_45cargodULmUFxnLsjIIlk_45mYZMxMou7QJClHSneqMwB_45bP_45qsMeta } from "/var/www/2025-07-16_14_46/pages/free-pickup-cargo.vue?macro=true";
import { default as calculator1FxkfG2vNl2C__45jNWg8AwA_DWsP9DyvHzqihlZvCdy0Meta } from "/var/www/2025-07-16_14_46/pages/iframe/calculator.vue?macro=true";
import { default as merch_45for_45bonusesLxTudhlxw_k2TwhhpEFC_3vOGNCS1OT9Y6hE9_cM030Meta } from "/var/www/2025-07-16_14_46/pages/merch-for-bonuses.vue?macro=true";
import { default as _91id_93NZ5yb8dtYbCcWOfqHJZDReMIpGmBf2zwh6bRf8i0ZN8Meta } from "/var/www/2025-07-16_14_46/pages/order/pay/qr/[id].vue?macro=true";
import { default as card_45infoQWdFGa__WUJG7ntOAJb_45vH2BphsQMd9NHqU8DV_wupAMeta } from "/var/www/2025-07-16_14_46/pages/payment/card-info.vue?macro=true";
import { default as discountVAM4saOdmbDuMAxB4MdRjki6gRzMcBGP0sLcel4_45d64Meta } from "/var/www/2025-07-16_14_46/pages/personal/discount.vue?macro=true";
import { default as hard_45boxoIkfhM0sqcvK85fevWsmhmDEUIvMYhPnU_4Y7vIdxCgMeta } from "/var/www/2025-07-16_14_46/pages/wrapping/hard-box.vue?macro=true";
import { default as forwarding_45receipt2YU6qNu4Bz5C7FGoP5fxT8XOZ85fQDkIz196gj4NkPgMeta } from "/var/www/2025-07-16_14_46/pages/forwarding-receipt.vue?macro=true";
import { default as mailClient10201917ixV0y25SE9VdFqzVQJimkXh3ZgEMz2H0mCUhEQlevKYMeta } from "/var/www/2025-07-16_14_46/pages/mailClient10201917.vue?macro=true";
import { default as mobile_45applicationvCV51hmEM_452XqzxFCAR2Kdf8wpJGHS862EWQMdQZbIcMeta } from "/var/www/2025-07-16_14_46/pages/mobile-application.vue?macro=true";
import { default as indexgE6wh_sLou_45VG429g9AzdGd2_PGtYzUTgqgoB7_ZlJoMeta } from "/var/www/2025-07-16_14_46/pages/order/create/index.vue?macro=true";
import { default as indexzdamc3hGt2uAzaHVcFQIvywSZkTzFyO8BgxjDwv5j60Meta } from "/var/www/2025-07-16_14_46/pages/run-schedule/index.vue?macro=true";
import { default as boatFgsGIyQDKvDqzANyhb3jnHLviZfBOLeviZvt_Q2P_45BIMeta } from "/var/www/2025-07-16_14_46/pages/shippingtypes/boat.vue?macro=true";
import { default as sofacUoM3Nm1E3194zY23rxBh4o7R8UV2PQNwIe34mCp5UIMeta } from "/var/www/2025-07-16_14_46/pages/shippingtypes/sofa.vue?macro=true";
import { default as _91location_93Czc3fSmjhGIrD4lHNvh9Bev0Cv42xQzogf9YyMlD4o8Meta } from "/var/www/2025-07-16_14_46/pages/tariffs/[location].vue?macro=true";
import { default as cardboard0rgmfPekonwSlW9wscdpAXt_ebj0Ua4GlIIT86GvOEkMeta } from "/var/www/2025-07-16_14_46/pages/wrapping/cardboard.vue?macro=true";
import { default as promocodesHhoTgxSoPV_45ouq2W1AXaPefnaZMIwSgiVeEbbyzLi_QMeta } from "/var/www/2025-07-16_14_46/pages/personal/promocodes.vue?macro=true";
import { default as bench4mXN8QvAeK_45wjzG4I49jzGbf0hBlJO7F4ff9XAl673UMeta } from "/var/www/2025-07-16_14_46/pages/shippingtypes/bench.vue?macro=true";
import { default as bookspygcrtIByMgJ5LhylrUAbm81MWFFjltKGpdyt0j2wLEMeta } from "/var/www/2025-07-16_14_46/pages/shippingtypes/books.vue?macro=true";
import { default as cablegDKf0WT_BLlJSxyFmtPe0A1L5sMxgXkP1_450hdOvf8LQMeta } from "/var/www/2025-07-16_14_46/pages/shippingtypes/cable.vue?macro=true";
import { default as chairwys0FZlAWH3tg14eDFVJZrCE644JoHyqbwWQN_E8bZAMeta } from "/var/www/2025-07-16_14_46/pages/shippingtypes/chair.vue?macro=true";
import { default as goods0koA1qgTE0SFG076Jfjq_45J8RliSRhbEJJO27zjxJCdwMeta } from "/var/www/2025-07-16_14_46/pages/shippingtypes/goods.vue?macro=true";
import { default as index8Hjav_VuV9WOwOT0fh9OKQZm7V8GQ_MPll0ByniRC_4Meta } from "/var/www/2025-07-16_14_46/pages/shippingtypes/index.vue?macro=true";
import { default as metalvmNs7CGN7WM6XGHcWUfQVShLoNxRC0YjGxSwn16KFLsMeta } from "/var/www/2025-07-16_14_46/pages/shippingtypes/metal.vue?macro=true";
import { default as pianoOrVW7fXKRTcLTjp1_45gJjPAn_NHlovgfRQJpS4Hm2JBEMeta } from "/var/www/2025-07-16_14_46/pages/shippingtypes/piano.vue?macro=true";
import { default as pipesJLlTmED_IuVkjRA_45pSRAiq7jCzAdERF_45UStISVuvEaAMeta } from "/var/www/2025-07-16_14_46/pages/shippingtypes/pipes.vue?macro=true";
import { default as tools7e6kNdhZETs8nQZ99CDNk5KUfVzgIJOkMbO3S50aSOUMeta } from "/var/www/2025-07-16_14_46/pages/shippingtypes/tools.vue?macro=true";
import { default as pallet_45boxwlaS_aIaRuv0JHmPYIsIOteDVOvRoUY3IJ3Q3T_1Qa8Meta } from "/var/www/2025-07-16_14_46/pages/wrapping/pallet-box.vue?macro=true";
import { default as _91tab_93uJoCU7bW0HUrPUYJr4Dc6USnkd5yP1kw4hgipIBipbMMeta } from "/var/www/2025-07-16_14_46/pages/personal/bonus/[tab].vue?macro=true";
import { default as printWqQwROz1xJDeyQYu5lGPUTnj_qJrkq4wyUqSqAistIsMeta } from "/var/www/2025-07-16_14_46/pages/personal/order/print.vue?macro=true";
import { default as dishesYiJD225YP27qxlgEb14mv37pCOHJ_CEEnwKVmFtuTeYMeta } from "/var/www/2025-07-16_14_46/pages/shippingtypes/dishes.vue?macro=true";
import { default as engined4GlUWTxc_d0Z85hUjNAdngeeQ6C8tNtTbp_45AJiOHY0Meta } from "/var/www/2025-07-16_14_46/pages/shippingtypes/engine.vue?macro=true";
import { default as lumberZ_S_45Bt1bzQu_R2qyUcGnjTTEaw7MmV9Xzd7to2JANzYMeta } from "/var/www/2025-07-16_14_46/pages/shippingtypes/lumber.vue?macro=true";
import { default as wheelsrSd1gOuzXH2Z2k76SbKrKWx9K91uQUHOBPNWFw7u6XAMeta } from "/var/www/2025-07-16_14_46/pages/shippingtypes/wheels.vue?macro=true";
import { default as bubble_45filmecbDFRxlxk3TfvyQCVAd074_45Y00kZ06IMRF2xmo9ovkMeta } from "/var/www/2025-07-16_14_46/pages/wrapping/bubble-film.vue?macro=true";
import { default as palletisingo7GXowo2PL5UndbGc9mWWwl_9dLC3ZBgMomXyCFC6QwMeta } from "/var/www/2025-07-16_14_46/pages/wrapping/palletising.vue?macro=true";
import { default as fast_45delivery_45capitalbXwIsxH_45MYrp_686RkTgRSL_mD_45hBF0bfmU5KPVgmS4Meta } from "/var/www/2025-07-16_14_46/pages/fast-delivery-capital.vue?macro=true";
import { default as _91guid_93a4JJq2HX_HSRMzZGZhwtSGZJ9PnxVnnlFHflnwN_455wEMeta } from "/var/www/2025-07-16_14_46/pages/personal/order/[guid].vue?macro=true";
import { default as createv4PgUjDnZ455oeFkteAIYd4ieasQwCF5TwdZMZXVH_45gMeta } from "/var/www/2025-07-16_14_46/pages/personal/order/create.vue?macro=true";
import { default as barrels6aTfApa8kduWWx37dcbQJXXkH8SqZDe_hEkogM7cKIUMeta } from "/var/www/2025-07-16_14_46/pages/shippingtypes/barrels.vue?macro=true";
import { default as clotheslWreoaupYBrGJudtE0m83aj2PHtQrtlfazpn9iKXM8YMeta } from "/var/www/2025-07-16_14_46/pages/shippingtypes/clothes.vue?macro=true";
import { default as fragileRjf6xvuTVEFFV7Q5IZChHcgbuL1ozeGDfEfs5iQBdJQMeta } from "/var/www/2025-07-16_14_46/pages/shippingtypes/fragile.vue?macro=true";
import { default as trailer77FZa1TsKEU19P1S0Bu8Zw5pZ_H_QyHUP2vFNTEnFlgMeta } from "/var/www/2025-07-16_14_46/pages/shippingtypes/trailer.vue?macro=true";
import { default as safe_45packagecBo0M_45LsRRbhcPkjM83lvKaa2mLZa3nGZejyoClMeEEMeta } from "/var/www/2025-07-16_14_46/pages/wrapping/safe-package.vue?macro=true";
import { default as bepaid_45successWMEuRAKGcH11WeEQzNkNxjYWXE5sTI4g1NDbiDKW6pcMeta } from "/var/www/2025-07-16_14_46/pages/payment/bepaid-success.vue?macro=true";
import { default as extra_45packageFk4er_45ja_45VceI6QNCAUd9CqYMDDr44_45Qo0SshddRk14Meta } from "/var/www/2025-07-16_14_46/pages/wrapping/extra-package.vue?macro=true";
import { default as wildberriesGpQPGLyfftRWLnY0P2drCke3b3HiXLhFlMWwYKfhMM8Meta } from "/var/www/2025-07-16_14_46/pages/marketplace/wildberries.vue?macro=true";
import { default as _91guid_93hqnCKRqaHOsG86mbecdF3IWW3FkgihstKVZyUvJxYx0Meta } from "/var/www/2025-07-16_14_46/pages/order/administer/[guid].vue?macro=true";
import { default as _91location_93w_YFqtMQWOCTL_45ePM1l_j_WVTrUsGnsPOg828mqBQR4Meta } from "/var/www/2025-07-16_14_46/pages/run-schedule/[location].vue?macro=true";
import { default as furniturejRZ5Zb4nKSpSU9DcV1o0s5OArLMrTSN2KGTAitjzHagMeta } from "/var/www/2025-07-16_14_46/pages/shippingtypes/furniture.vue?macro=true";
import { default as oversized31ZqqflTineTUh_45DwvYg_38p_XYa_4520jNUhfSyBvbb0Meta } from "/var/www/2025-07-16_14_46/pages/shippingtypes/oversized.vue?macro=true";
import { default as quad_45biketS7ek3knEqWqxacOh65OovmRRx3DsjJ_45sUG4MQE3zo4Meta } from "/var/www/2025-07-16_14_46/pages/shippingtypes/quad-bike.vue?macro=true";
import { default as _91locations_93ib29WcTgWFueQLEwvCM0F9no9UqupjTn_RglovX3q4UMeta } from "/var/www/2025-07-16_14_46/pages/order/create/[locations].vue?macro=true";
import { default as _91_46_46_46tab_930_45Sq9QuByqWFy2IMys6_45vHuKNHVhxeT_wjeHVyIoKsoMeta } from "/var/www/2025-07-16_14_46/pages/personal/orders/[...tab].vue?macro=true";
import { default as auto_45partsQKRrheEfMbYl8ej15GLgaefAcHV84kkNHKE8q_45EeZ48Meta } from "/var/www/2025-07-16_14_46/pages/shippingtypes/auto-parts.vue?macro=true";
import { default as newspapers9C0rIAt7u_cyvMx_456ookc9B70dVXKH_q7ez_4xfsIMsMeta } from "/var/www/2025-07-16_14_46/pages/shippingtypes/newspapers.vue?macro=true";
import { default as smallcargoOZDuOBRyoGZns_45yVAdQnot1b_cTU0EZulDs0EJmeRvMMeta } from "/var/www/2025-07-16_14_46/pages/shippingtypes/smallcargo.vue?macro=true";
import { default as snowmobile_45p82NtZzSGiC_45HVKpGmyg3zRLXZ6Uo0SdBkFYSk9LO4Meta } from "/var/www/2025-07-16_14_46/pages/shippingtypes/snowmobile.vue?macro=true";
import { default as indexqJ0cNwqRaF3TTXX1rDRdaKe__fTtrLMV0QU9BYeGj8wMeta } from "/var/www/2025-07-16_14_46/pages/iframe/order/create/index.vue?macro=true";
import { default as yandex_45marketSoqhGDnDYdL48icTvXYn3_45osEsE__Vww0yephGFy0fEMeta } from "/var/www/2025-07-16_14_46/pages/marketplace/yandex-market.vue?macro=true";
import { default as templatesxJwgioeUH39GuFkZ1bhn5JIyqcjulgo4scQ_zt3HEHAMeta } from "/var/www/2025-07-16_14_46/pages/personal/orders/templates.vue?macro=true";
import { default as indexYFCXL8aTccM0_dUMvDIizTu06MyoWMcVfIdpiWoNE_sMeta } from "/var/www/2025-07-16_14_46/pages/personal/contractors/index.vue?macro=true";
import { default as refrigeratorHQenMtYBlH_45S2E7knKwjr7yGHzzRa5l9SgHOst0OUlgMeta } from "/var/www/2025-07-16_14_46/pages/shippingtypes/refrigerator.vue?macro=true";
import { default as _91guid_93NPQ3NVSWHolrAPsTPLOglJ8a6WMKoTcZCDzteA3QDp8Meta } from "/var/www/2025-07-16_14_46/pages/personal/contractors/[guid].vue?macro=true";
import { default as indexndSzJ_45uxvm7bVlnwrcTS57vYW2uvUI7JHbltM7Yct1QMeta } from "/var/www/2025-07-16_14_46/pages/personal/multi-pickup/index.vue?macro=true";
import { default as _91guid_93oRhxabyoF_45TDpTsbilSqWyhHkkaaIhpK3sruB2iiGk4Meta } from "/var/www/2025-07-16_14_46/pages/personal/multi-pickup/[guid].vue?macro=true";
import { default as consumer_45goodspu3mzCx_Au2cVTXzq2RVKOFSRBu5Qw_45BWaORtF_oOxkMeta } from "/var/www/2025-07-16_14_46/pages/shippingtypes/consumer-goods.vue?macro=true";
import { default as indexFSTehX4z8sTT48wgUzfxiJGmKwne9hIoXno83bpYAJ4Meta } from "/var/www/2025-07-16_14_46/pages/personal/group-printing/index.vue?macro=true";
import { default as indexB_zl_45DQ8cigf9qow7uYzgo714id6zEUvDSINNx9tEbYMeta } from "/var/www/2025-07-16_14_46/pages/personal/multi-delivery/index.vue?macro=true";
import { default as medical_45devicesCSaz4A_45SOvA_45B97ANUV3qQp8OsiwyRc9_45L067ss6FioMeta } from "/var/www/2025-07-16_14_46/pages/shippingtypes/medical-devices.vue?macro=true";
import { default as _91guid_93Vr7vuhdrYkpjeO7byukZIxcNjaLDt10XsYPNk_c59XAMeta } from "/var/www/2025-07-16_14_46/pages/iframe/order/administer/[guid].vue?macro=true";
import { default as _91guid_93qksLFxT9EIDQHfvnbhtxDn1UOIRKZeqSbKY3xeOS4XoMeta } from "/var/www/2025-07-16_14_46/pages/personal/multi-delivery/[guid].vue?macro=true";
import { default as _91_46_46_46id_93u_45Q5p9tS_45ktKPgvj_45xK_Jfdee4Gn08X_NWDK5C_45hshUMeta } from "/var/www/2025-07-16_14_46/pages/personal/order/template/[...id].vue?macro=true";
import { default as special_45equipmentmq3NWVeE_45_45aHAf89NdeQiugVbZ9xY5_45UWBx5nNMAYGYMeta } from "/var/www/2025-07-16_14_46/pages/shippingtypes/special-equipment.vue?macro=true";
import { default as building_45materialspemqCoaeS7nGE4Xb3fNbDObviBVNjrBzwNZNCcbs5QoMeta } from "/var/www/2025-07-16_14_46/pages/shippingtypes/building-materials.vue?macro=true";
import { default as musical_45instrumentsciTBNXgpFdLwOee5hc9Dh44iYq2q9k_451SC3n94YGKyYMeta } from "/var/www/2025-07-16_14_46/pages/shippingtypes/musical-instruments.vue?macro=true";
import { default as industrial_45equipmentA1zJOQgVHdZ6EwJ9KJCi0K309Sf_NjpQRqVSa3etzC0Meta } from "/var/www/2025-07-16_14_46/pages/shippingtypes/industrial-equipment.vue?macro=true";
import { default as motorcycletransportationeY5EMRww1inHYzfL3w_45ZFypaLRkzQOgOOdmUjN7YwIEMeta } from "/var/www/2025-07-16_14_46/pages/shippingtypes/motorcycletransportation.vue?macro=true";
import { default as _91locationFrom_93__91locationTo_93d4bCX_45HlNoSPPbb5cfUht3wlbJmw_jI4GWJC3ooLJVUMeta } from "/var/www/2025-07-16_14_46/pages/order/create/[locationFrom]_[locationTo].vue?macro=true";
import { default as personalitemstransportationQwkRovq0pJcex0loJ4Tb9_N5lIAOxIz7oemgZ8rOiDsMeta } from "/var/www/2025-07-16_14_46/pages/shippingtypes/personalitemstransportation.vue?macro=true";
export default [
  {
    name: "edo",
    path: "/edo",
    component: () => import("/var/www/2025-07-16_14_46/pages/edo.vue")
  },
  {
    name: "help",
    path: "/help",
    component: () => import("/var/www/2025-07-16_14_46/pages/help.vue")
  },
  {
    name: "cargo",
    path: "/cargo",
    component: () => import("/var/www/2025-07-16_14_46/pages/cargo.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/var/www/2025-07-16_14_46/pages/index.vue")
  },
  {
    name: "slug",
    path: "/:slug()",
    meta: _91slug_93a7ZDgwtdYXEmYNgE6fbkrnwLmoOIUJg6bVDldfASBh8Meta || {},
    component: () => import("/var/www/2025-07-16_14_46/pages/[slug].vue")
  },
  {
    name: "cookie",
    path: "/cookie",
    component: () => import("/var/www/2025-07-16_14_46/pages/cookie.vue")
  },
  {
    name: "survey",
    path: "/survey/:surveyId/",
    meta: surveyqXk_59xgngMqMYHadawrAYLzAhS_JhzZ_oKUjazNN84Meta || {},
    component: () => import("/var/www/2025-07-16_14_46/pages/survey.vue")
  },
  {
    name: "belarus",
    path: "/belarus",
    component: () => import("/var/www/2025-07-16_14_46/pages/belarus.vue")
  },
  {
    name: "bonuses",
    path: "/bonuses",
    component: () => import("/var/www/2025-07-16_14_46/pages/bonuses.vue")
  },
  {
    name: "dev-api",
    path: "/dev/api",
    component: () => import("/var/www/2025-07-16_14_46/pages/dev/api.vue")
  },
  {
    name: "dev-cms",
    path: "/dev/cms",
    component: () => import("/var/www/2025-07-16_14_46/pages/dev/cms.vue")
  },
  {
    name: "konkurs",
    path: "/konkurs",
    meta: konkurscLlAKBnPegeq5C6MlCtQYNa_tPcDArmgeSeHrcgW7NIMeta || {},
    component: () => import("/var/www/2025-07-16_14_46/pages/konkurs.vue")
  },
  {
    name: "success",
    path: "/success",
    component: () => import("/var/www/2025-07-16_14_46/pages/success.vue")
  },
  {
    name: "vacancy",
    path: "/vacancy",
    component: () => import("/var/www/2025-07-16_14_46/pages/vacancy.vue")
  },
  {
    name: "contacts",
    path: "/:tag(address|contacts)/:location?",
    meta: contactsAnx_cR_45rlvpIEGtDLgf7ElEvTADkiXkmwKlIe09oBs0Meta || {},
    component: () => import("/var/www/2025-07-16_14_46/pages/contacts.vue")
  },
  {
    name: "giveaway",
    path: "/giveaway",
    component: () => import("/var/www/2025-07-16_14_46/pages/giveaway.vue")
  },
  {
    name: "guide-lk",
    path: "/guide-lk",
    component: () => import("/var/www/2025-07-16_14_46/pages/guide-lk.vue")
  },
  {
    name: "services",
    path: "/services",
    component: () => import("/var/www/2025-07-16_14_46/pages/services.vue")
  },
  {
    name: "telegram",
    path: "/telegram",
    component: () => import("/var/www/2025-07-16_14_46/pages/telegram.vue")
  },
  {
    name: "documents",
    path: "/documents",
    component: () => import("/var/www/2025-07-16_14_46/pages/documents.vue")
  },
  {
    name: "franchise",
    path: "/franchise",
    component: () => import("/var/www/2025-07-16_14_46/pages/franchise.vue")
  },
  {
    name: "insurance",
    path: "/insurance",
    component: () => import("/var/www/2025-07-16_14_46/pages/insurance.vue")
  },
  {
    name: "kirghizia",
    path: "/kirghizia",
    component: () => import("/var/www/2025-07-16_14_46/pages/kirghizia.vue")
  },
  {
    name: "mapScheme",
    path: "/mapScheme",
    meta: mapSchememYY5Xcs9PcBijsD8MAr1vVEL_45c4VsDb3aeDRecMyQmgMeta || {},
    component: () => import("/var/www/2025-07-16_14_46/pages/mapScheme.vue")
  },
  {
    name: "news-id",
    path: "/:tag(news|actions)/:id",
    meta: _91id_93Cz_5Vj9TBDboBQCIbe_450JpRQs4XzbqPKsVzJOMuiqQcMeta || {},
    component: () => import("/var/www/2025-07-16_14_46/pages/news/[id].vue")
  },
  {
    name: "return-sd",
    path: "/return-sd",
    component: () => import("/var/www/2025-07-16_14_46/pages/return-sd.vue")
  },
  {
    name: "smsClient",
    path: "/smsClient",
    component: () => import("/var/www/2025-07-16_14_46/pages/smsClient.vue")
  },
  {
    name: "terminals",
    path: "/terminals",
    component: () => import("/var/www/2025-07-16_14_46/pages/terminals.vue")
  },
  {
    name: "dev-iframe",
    path: "/dev/iframe",
    component: () => import("/var/www/2025-07-16_14_46/pages/dev/iframe.vue")
  },
  {
    name: "directions",
    path: "/directions",
    component: () => import("/var/www/2025-07-16_14_46/pages/directions.vue")
  },
  {
    name: "kazakhstan",
    path: "/kazakhstan",
    component: () => import("/var/www/2025-07-16_14_46/pages/kazakhstan.vue")
  },
  {
    name: "news",
    path: "/:tag(news|actions)",
    meta: indexqw_45kTrAu91kADWZhniKn6k7PbQsRNaLJQl9lCepvRnoMeta || {},
    component: () => import("/var/www/2025-07-16_14_46/pages/news/index.vue")
  },
  {
    name: "ui-kit-svg",
    path: "/ui-kit/svg",
    component: () => import("/var/www/2025-07-16_14_46/pages/ui-kit/svg.vue")
  },
  {
    name: "vzpay-fail",
    path: "/vzpay-fail",
    component: () => import("/var/www/2025-07-16_14_46/pages/vzpay-fail.vue")
  },
  {
    name: "constructor",
    path: "/constructor",
    meta: constructormkkTDwrpmMi65C_45QsJp9TomqwOZirHdCMENM1U8j1zgMeta || {},
    component: () => import("/var/www/2025-07-16_14_46/pages/constructor.vue")
  },
  {
    name: "gifts",
    path: "/gifts",
    meta: indexJBMeZsKX8Xx4qbzB9KW5pCMgFnIEU5hAq1isHWiB8c4Meta || {},
    component: () => import("/var/www/2025-07-16_14_46/pages/gifts/index.vue")
  },
  {
    name: "information",
    path: "/information",
    component: () => import("/var/www/2025-07-16_14_46/pages/information.vue")
  },
  {
    name: "order-light",
    path: "/order/light",
    component: () => import("/var/www/2025-07-16_14_46/pages/order/light.vue")
  },
  {
    name: "claim-filing",
    path: "/claim-filing",
    component: () => import("/var/www/2025-07-16_14_46/pages/claim-filing.vue")
  },
  {
    name: "gifts-type",
    path: "/gift/:type(m|o)",
    meta: _91type_93q6cIFPkxbrGfsfJcYGzUId_45zO4e29nOiGCmrlKNha9oMeta || {},
    component: () => import("/var/www/2025-07-16_14_46/pages/gifts/[type].vue")
  },
  {
    name: "marketplaces",
    path: "/marketplaces",
    component: () => import("/var/www/2025-07-16_14_46/pages/marketplaces.vue")
  },
  {
    name: "networkshops",
    path: "/networkshops",
    component: () => import("/var/www/2025-07-16_14_46/pages/networkshops.vue")
  },
  {
    name: "online-store",
    path: "/online-store",
    component: () => import("/var/www/2025-07-16_14_46/pages/online-store.vue")
  },
  {
    name: "order-manage",
    path: "/order/manage",
    component: () => import("/var/www/2025-07-16_14_46/pages/order/manage.vue")
  },
  {
    name: "registration",
    path: "/registration",
    component: () => import("/var/www/2025-07-16_14_46/pages/registration.vue")
  },
  {
    name: "safe-custody",
    path: "/safe-custody",
    component: () => import("/var/www/2025-07-16_14_46/pages/safe-custody.vue")
  },
  {
    name: "ui-kit-image",
    path: "/ui-kit/image",
    component: () => import("/var/www/2025-07-16_14_46/pages/ui-kit/image.vue")
  },
  {
    name: "ui-kit",
    path: "/ui-kit",
    component: () => import("/var/www/2025-07-16_14_46/pages/ui-kit/index.vue")
  },
  {
    name: "wrapping-bag",
    path: "/wrapping/bag",
    component: () => import("/var/www/2025-07-16_14_46/pages/wrapping/bag.vue")
  },
  {
    name: "wrapping-box",
    path: "/wrapping/box",
    component: () => import("/var/www/2025-07-16_14_46/pages/wrapping/box.vue")
  },
  {
    name: "cargo-loading",
    path: "/cargo-loading",
    component: () => import("/var/www/2025-07-16_14_46/pages/cargo-loading.vue")
  },
  {
    name: "happybirthday",
    path: "/happybirthday",
    meta: happybirthdaypv0kUk1UDdXSS_tWHG2Df19eyB8N4ozofk_od43gEE4Meta || {},
    component: () => import("/var/www/2025-07-16_14_46/pages/happybirthday.vue")
  },
  {
    name: "iframe-manage",
    path: "/iframe/manage",
    meta: manageYZnHhiXg_45I_M9Lgbwj8bhUzZN4WZvmBkNPeS75x8pxQMeta || {},
    component: () => import("/var/www/2025-07-16_14_46/pages/iframe/manage.vue")
  },
  {
    name: "personal-auth",
    path: "/personal/auth",
    component: () => import("/var/www/2025-07-16_14_46/pages/personal/auth.vue")
  },
  {
    name: "tariffs",
    path: "/tariffs",
    component: () => import("/var/www/2025-07-16_14_46/pages/tariffs/index.vue")
  },
  {
    name: "ui-kit-public",
    path: "/ui-kit/public",
    component: () => import("/var/www/2025-07-16_14_46/pages/ui-kit/public.vue")
  },
  {
    name: "already-answer",
    path: "/already-answer",
    component: () => import("/var/www/2025-07-16_14_46/pages/already-answer.vue")
  },
  {
    name: "iframe-tariffs",
    path: "/iframe/tariffs",
    meta: tariffsPiTVDtglUouYcwcK_M_45Nsdi_45IPpZfpZUJu1Re4v7_45T8Meta || {},
    component: () => import("/var/www/2025-07-16_14_46/pages/iframe/tariffs.vue")
  },
  {
    name: "order-pay-id",
    path: "/order/pay/:id()",
    component: () => import("/var/www/2025-07-16_14_46/pages/order/pay/[id].vue")
  },
  {
    name: "personal",
    path: "/personal",
    meta: indexoJc7qteZzE1PQjib0Mb7C_GrLUBeDSVLMqAZxjQjsTgMeta || {},
    component: () => import("/var/www/2025-07-16_14_46/pages/personal/index.vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    component: () => import("/var/www/2025-07-16_14_46/pages/privacy-policy.vue")
  },
  {
    name: "welcome-hash",
    path: "/welcome/:hash()",
    component: () => import("/var/www/2025-07-16_14_46/pages/welcome/[hash].vue")
  },
  {
    name: "wrapping",
    path: "/wrapping",
    component: () => import("/var/www/2025-07-16_14_46/pages/wrapping/index.vue")
  },
  {
    name: "delivery-russia",
    path: "/delivery-russia",
    component: () => import("/var/www/2025-07-16_14_46/pages/delivery-russia.vue")
  },
  {
    name: "payment-methods",
    path: "/payment-methods",
    component: () => import("/var/www/2025-07-16_14_46/pages/payment-methods.vue")
  },
  {
    name: "payment-qr-info",
    path: "/payment/qr-info",
    component: () => import("/var/www/2025-07-16_14_46/pages/payment/qr-info.vue")
  },
  {
    name: "payment-success",
    path: "/payment/success",
    component: () => import("/var/www/2025-07-16_14_46/pages/payment/success.vue")
  },
  {
    name: "personal-import",
    path: "/personal/import",
    meta: importR6GQ84DnRzJ9XpP8rn0RWvitNjXJNDh0mdVprKtBkswMeta || {},
    component: () => import("/var/www/2025-07-16_14_46/pages/personal/import.vue")
  },
  {
    name: "personal-logout",
    path: "/personal/logout",
    meta: logoutG0ClCEb2kEdseV0SIouGtOEJW6k1zPTbpFlZmCoBbzIMeta || {},
    component: () => import("/var/www/2025-07-16_14_46/pages/personal/logout.vue")
  },
  {
    name: "address-delivery",
    path: "/address-delivery",
    component: () => import("/var/www/2025-07-16_14_46/pages/address-delivery.vue")
  },
  {
    name: "cash-on-delivery",
    path: "/cash-on-delivery",
    component: () => import("/var/www/2025-07-16_14_46/pages/cash-on-delivery.vue")
  },
  {
    name: "happynewyear2024",
    path: "/happynewyear2024",
    meta: happynewyear2024NAEGn9bwkU9sbmHSQ1LW1ukzhHVAoHEbiqyr7XxWQ0MMeta || {},
    component: () => import("/var/www/2025-07-16_14_46/pages/happynewyear2024.vue")
  },
  {
    name: "marketplace-ozon",
    path: "/ozon",
    meta: ozonWfRhJd_6mOVCGsBpBVAL18yv7iBSe9hn6nABRktL5IAMeta || {},
    component: () => import("/var/www/2025-07-16_14_46/pages/marketplace/ozon.vue")
  },
  {
    name: "payment-pay-fail",
    path: "/payment/pay-fail",
    component: () => import("/var/www/2025-07-16_14_46/pages/payment/pay-fail.vue")
  },
  {
    name: "personal-account",
    path: "/personal/account",
    meta: account_K_45MYpfp8s95qL1n2NObaQVGByh0w61BGCpuNyU39SAMeta || {},
    component: () => import("/var/www/2025-07-16_14_46/pages/personal/account.vue")
  },
  {
    name: "prohibited-goods",
    path: "/prohibited-goods",
    component: () => import("/var/www/2025-07-16_14_46/pages/prohibited-goods.vue")
  },
  {
    name: "survey-completed",
    path: "/survey-completed",
    meta: survey_45completedNOOcZXPJUJIqGhFx8GdP31rW0uOjKk2vof6bhU1gwQIMeta || {},
    component: () => import("/var/www/2025-07-16_14_46/pages/survey-completed.vue")
  },
  {
    name: "ui-kit-direction",
    path: "/ui-kit/direction",
    component: () => import("/var/www/2025-07-16_14_46/pages/ui-kit/direction.vue")
  },
  {
    name: "free-group-pickup",
    path: "/free-group-pickup",
    component: () => import("/var/www/2025-07-16_14_46/pages/free-group-pickup.vue")
  },
  {
    name: "free-pickup-cargo",
    path: "/free-pickup-cargo",
    component: () => import("/var/www/2025-07-16_14_46/pages/free-pickup-cargo.vue")
  },
  {
    name: "iframe-calculator",
    path: "/iframe/calculator",
    meta: calculator1FxkfG2vNl2C__45jNWg8AwA_DWsP9DyvHzqihlZvCdy0Meta || {},
    component: () => import("/var/www/2025-07-16_14_46/pages/iframe/calculator.vue")
  },
  {
    name: "merch-for-bonuses",
    path: "/merch-for-bonuses",
    component: () => import("/var/www/2025-07-16_14_46/pages/merch-for-bonuses.vue")
  },
  {
    name: "order-pay-qr-id",
    path: "/order/pay/qr/:id()",
    component: () => import("/var/www/2025-07-16_14_46/pages/order/pay/qr/[id].vue")
  },
  {
    name: "payment-card-info",
    path: "/payment/card-info",
    component: () => import("/var/www/2025-07-16_14_46/pages/payment/card-info.vue")
  },
  {
    name: "personal-discount",
    path: "/personal/discount",
    meta: discountVAM4saOdmbDuMAxB4MdRjki6gRzMcBGP0sLcel4_45d64Meta || {},
    component: () => import("/var/www/2025-07-16_14_46/pages/personal/discount.vue")
  },
  {
    name: "wrapping-hard-box",
    path: "/wrapping/hard-box",
    component: () => import("/var/www/2025-07-16_14_46/pages/wrapping/hard-box.vue")
  },
  {
    name: "forwarding-receipt",
    path: "/forwarding-receipt",
    component: () => import("/var/www/2025-07-16_14_46/pages/forwarding-receipt.vue")
  },
  {
    name: "mailClient10201917",
    path: "/mailClient10201917",
    meta: mailClient10201917ixV0y25SE9VdFqzVQJimkXh3ZgEMz2H0mCUhEQlevKYMeta || {},
    component: () => import("/var/www/2025-07-16_14_46/pages/mailClient10201917.vue")
  },
  {
    name: "mobile-application",
    path: "/mobile-application",
    component: () => import("/var/www/2025-07-16_14_46/pages/mobile-application.vue")
  },
  {
    name: "order-create",
    path: "/order/create",
    meta: indexgE6wh_sLou_45VG429g9AzdGd2_PGtYzUTgqgoB7_ZlJoMeta || {},
    component: () => import("/var/www/2025-07-16_14_46/pages/order/create/index.vue")
  },
  {
    name: "run-schedule",
    path: "/run-schedule",
    component: () => import("/var/www/2025-07-16_14_46/pages/run-schedule/index.vue")
  },
  {
    name: "shippingtypes-boat",
    path: "/shippingtypes/boat",
    component: () => import("/var/www/2025-07-16_14_46/pages/shippingtypes/boat.vue")
  },
  {
    name: "shippingtypes-sofa",
    path: "/shippingtypes/sofa",
    component: () => import("/var/www/2025-07-16_14_46/pages/shippingtypes/sofa.vue")
  },
  {
    name: "tariffs-location",
    path: "/tariffs/:location()",
    component: () => import("/var/www/2025-07-16_14_46/pages/tariffs/[location].vue")
  },
  {
    name: "wrapping-cardboard",
    path: "/wrapping/cardboard",
    component: () => import("/var/www/2025-07-16_14_46/pages/wrapping/cardboard.vue")
  },
  {
    name: "personal-promocodes",
    path: "/personal/promocodes",
    meta: promocodesHhoTgxSoPV_45ouq2W1AXaPefnaZMIwSgiVeEbbyzLi_QMeta || {},
    component: () => import("/var/www/2025-07-16_14_46/pages/personal/promocodes.vue")
  },
  {
    name: "shippingtypes-bench",
    path: "/shippingtypes/bench",
    component: () => import("/var/www/2025-07-16_14_46/pages/shippingtypes/bench.vue")
  },
  {
    name: "shippingtypes-books",
    path: "/shippingtypes/books",
    component: () => import("/var/www/2025-07-16_14_46/pages/shippingtypes/books.vue")
  },
  {
    name: "shippingtypes-cable",
    path: "/shippingtypes/cable",
    component: () => import("/var/www/2025-07-16_14_46/pages/shippingtypes/cable.vue")
  },
  {
    name: "shippingtypes-chair",
    path: "/shippingtypes/chair",
    component: () => import("/var/www/2025-07-16_14_46/pages/shippingtypes/chair.vue")
  },
  {
    name: "shippingtypes-goods",
    path: "/shippingtypes/goods",
    component: () => import("/var/www/2025-07-16_14_46/pages/shippingtypes/goods.vue")
  },
  {
    name: "shippingtypes",
    path: "/shippingtypes",
    component: () => import("/var/www/2025-07-16_14_46/pages/shippingtypes/index.vue")
  },
  {
    name: "shippingtypes-metal",
    path: "/shippingtypes/metal",
    component: () => import("/var/www/2025-07-16_14_46/pages/shippingtypes/metal.vue")
  },
  {
    name: "shippingtypes-piano",
    path: "/shippingtypes/piano",
    component: () => import("/var/www/2025-07-16_14_46/pages/shippingtypes/piano.vue")
  },
  {
    name: "shippingtypes-pipes",
    path: "/shippingtypes/pipes",
    component: () => import("/var/www/2025-07-16_14_46/pages/shippingtypes/pipes.vue")
  },
  {
    name: "shippingtypes-tools",
    path: "/shippingtypes/tools",
    component: () => import("/var/www/2025-07-16_14_46/pages/shippingtypes/tools.vue")
  },
  {
    name: "wrapping-pallet-box",
    path: "/wrapping/pallet-box",
    component: () => import("/var/www/2025-07-16_14_46/pages/wrapping/pallet-box.vue")
  },
  {
    name: "personal-bonus-tab",
    path: "/personal/bonus/:tab()",
    meta: _91tab_93uJoCU7bW0HUrPUYJr4Dc6USnkd5yP1kw4hgipIBipbMMeta || {},
    component: () => import("/var/www/2025-07-16_14_46/pages/personal/bonus/[tab].vue")
  },
  {
    name: "personal-order-print",
    path: "/personal/order/print",
    meta: printWqQwROz1xJDeyQYu5lGPUTnj_qJrkq4wyUqSqAistIsMeta || {},
    component: () => import("/var/www/2025-07-16_14_46/pages/personal/order/print.vue")
  },
  {
    name: "shippingtypes-dishes",
    path: "/shippingtypes/dishes",
    component: () => import("/var/www/2025-07-16_14_46/pages/shippingtypes/dishes.vue")
  },
  {
    name: "shippingtypes-engine",
    path: "/shippingtypes/engine",
    component: () => import("/var/www/2025-07-16_14_46/pages/shippingtypes/engine.vue")
  },
  {
    name: "shippingtypes-lumber",
    path: "/shippingtypes/lumber",
    component: () => import("/var/www/2025-07-16_14_46/pages/shippingtypes/lumber.vue")
  },
  {
    name: "shippingtypes-wheels",
    path: "/shippingtypes/wheels",
    component: () => import("/var/www/2025-07-16_14_46/pages/shippingtypes/wheels.vue")
  },
  {
    name: "wrapping-bubble-film",
    path: "/wrapping/bubble-film",
    component: () => import("/var/www/2025-07-16_14_46/pages/wrapping/bubble-film.vue")
  },
  {
    name: "wrapping-palletising",
    path: "/wrapping/palletising",
    component: () => import("/var/www/2025-07-16_14_46/pages/wrapping/palletising.vue")
  },
  {
    name: "fast-delivery-capital",
    path: "/fast-delivery-capital",
    component: () => import("/var/www/2025-07-16_14_46/pages/fast-delivery-capital.vue")
  },
  {
    name: "personal-order-guid",
    path: "/personal/order/:tag(pay)?/:guid",
    meta: _91guid_93a4JJq2HX_HSRMzZGZhwtSGZJ9PnxVnnlFHflnwN_455wEMeta || {},
    component: () => import("/var/www/2025-07-16_14_46/pages/personal/order/[guid].vue")
  },
  {
    name: "personal-order-create",
    path: "/personal/order/create",
    meta: createv4PgUjDnZ455oeFkteAIYd4ieasQwCF5TwdZMZXVH_45gMeta || {},
    component: () => import("/var/www/2025-07-16_14_46/pages/personal/order/create.vue")
  },
  {
    name: "shippingtypes-barrels",
    path: "/shippingtypes/barrels",
    component: () => import("/var/www/2025-07-16_14_46/pages/shippingtypes/barrels.vue")
  },
  {
    name: "shippingtypes-clothes",
    path: "/shippingtypes/clothes",
    component: () => import("/var/www/2025-07-16_14_46/pages/shippingtypes/clothes.vue")
  },
  {
    name: "shippingtypes-fragile",
    path: "/shippingtypes/fragile",
    component: () => import("/var/www/2025-07-16_14_46/pages/shippingtypes/fragile.vue")
  },
  {
    name: "shippingtypes-trailer",
    path: "/shippingtypes/trailer",
    component: () => import("/var/www/2025-07-16_14_46/pages/shippingtypes/trailer.vue")
  },
  {
    name: "wrapping-safe-package",
    path: "/wrapping/safe-package",
    component: () => import("/var/www/2025-07-16_14_46/pages/wrapping/safe-package.vue")
  },
  {
    name: "payment-bepaid-success",
    path: "/payment/bepaid-success",
    component: () => import("/var/www/2025-07-16_14_46/pages/payment/bepaid-success.vue")
  },
  {
    name: "wrapping-extra-package",
    path: "/wrapping/extra-package",
    component: () => import("/var/www/2025-07-16_14_46/pages/wrapping/extra-package.vue")
  },
  {
    name: "marketplace-wildberries",
    path: "/wildberries",
    meta: wildberriesGpQPGLyfftRWLnY0P2drCke3b3HiXLhFlMWwYKfhMM8Meta || {},
    component: () => import("/var/www/2025-07-16_14_46/pages/marketplace/wildberries.vue")
  },
  {
    name: "order-administer-guid",
    path: "/order/administer/:guid()",
    component: () => import("/var/www/2025-07-16_14_46/pages/order/administer/[guid].vue")
  },
  {
    name: "run-schedule-location",
    path: "/run-schedule/:location()",
    component: () => import("/var/www/2025-07-16_14_46/pages/run-schedule/[location].vue")
  },
  {
    name: "shippingtypes-furniture",
    path: "/shippingtypes/furniture",
    component: () => import("/var/www/2025-07-16_14_46/pages/shippingtypes/furniture.vue")
  },
  {
    name: "shippingtypes-oversized",
    path: "/shippingtypes/oversized",
    component: () => import("/var/www/2025-07-16_14_46/pages/shippingtypes/oversized.vue")
  },
  {
    name: "shippingtypes-quad-bike",
    path: "/shippingtypes/quad-bike",
    component: () => import("/var/www/2025-07-16_14_46/pages/shippingtypes/quad-bike.vue")
  },
  {
    name: "order-create-locations",
    path: "/order/create/:locations()",
    component: () => import("/var/www/2025-07-16_14_46/pages/order/create/[locations].vue")
  },
  {
    name: "personal-orders-tab",
    path: "/personal/orders/:tab(.*)*",
    meta: _91_46_46_46tab_930_45Sq9QuByqWFy2IMys6_45vHuKNHVhxeT_wjeHVyIoKsoMeta || {},
    component: () => import("/var/www/2025-07-16_14_46/pages/personal/orders/[...tab].vue")
  },
  {
    name: "shippingtypes-auto-parts",
    path: "/shippingtypes/auto-parts",
    component: () => import("/var/www/2025-07-16_14_46/pages/shippingtypes/auto-parts.vue")
  },
  {
    name: "shippingtypes-newspapers",
    path: "/shippingtypes/newspapers",
    component: () => import("/var/www/2025-07-16_14_46/pages/shippingtypes/newspapers.vue")
  },
  {
    name: "shippingtypes-smallcargo",
    path: "/shippingtypes/smallcargo",
    component: () => import("/var/www/2025-07-16_14_46/pages/shippingtypes/smallcargo.vue")
  },
  {
    name: "shippingtypes-snowmobile",
    path: "/shippingtypes/snowmobile",
    component: () => import("/var/www/2025-07-16_14_46/pages/shippingtypes/snowmobile.vue")
  },
  {
    name: "iframe-order-create",
    path: "/iframe/order/create",
    meta: indexqJ0cNwqRaF3TTXX1rDRdaKe__fTtrLMV0QU9BYeGj8wMeta || {},
    component: () => import("/var/www/2025-07-16_14_46/pages/iframe/order/create/index.vue")
  },
  {
    name: "marketplace-yandex-market",
    path: "/yandex-market",
    meta: yandex_45marketSoqhGDnDYdL48icTvXYn3_45osEsE__Vww0yephGFy0fEMeta || {},
    component: () => import("/var/www/2025-07-16_14_46/pages/marketplace/yandex-market.vue")
  },
  {
    name: "personal-orders-templates",
    path: "/personal/orders/templates",
    meta: templatesxJwgioeUH39GuFkZ1bhn5JIyqcjulgo4scQ_zt3HEHAMeta || {},
    component: () => import("/var/www/2025-07-16_14_46/pages/personal/orders/templates.vue")
  },
  {
    name: "personal-contractors",
    path: "/personal/contractors",
    meta: indexYFCXL8aTccM0_dUMvDIizTu06MyoWMcVfIdpiWoNE_sMeta || {},
    component: () => import("/var/www/2025-07-16_14_46/pages/personal/contractors/index.vue")
  },
  {
    name: "shippingtypes-refrigerator",
    path: "/shippingtypes/refrigerator",
    component: () => import("/var/www/2025-07-16_14_46/pages/shippingtypes/refrigerator.vue")
  },
  {
    name: "personal-contractors-guid",
    path: "/personal/contractors/:guid()",
    meta: _91guid_93NPQ3NVSWHolrAPsTPLOglJ8a6WMKoTcZCDzteA3QDp8Meta || {},
    component: () => import("/var/www/2025-07-16_14_46/pages/personal/contractors/[guid].vue")
  },
  {
    name: "personal-multi-pickup",
    path: "/personal/multi-pickup",
    meta: indexndSzJ_45uxvm7bVlnwrcTS57vYW2uvUI7JHbltM7Yct1QMeta || {},
    component: () => import("/var/www/2025-07-16_14_46/pages/personal/multi-pickup/index.vue")
  },
  {
    name: "personal-multi-pickup-guid",
    path: "/personal/multi-pickup/:guid",
    meta: _91guid_93oRhxabyoF_45TDpTsbilSqWyhHkkaaIhpK3sruB2iiGk4Meta || {},
    component: () => import("/var/www/2025-07-16_14_46/pages/personal/multi-pickup/[guid].vue")
  },
  {
    name: "shippingtypes-consumer-goods",
    path: "/shippingtypes/consumer-goods",
    component: () => import("/var/www/2025-07-16_14_46/pages/shippingtypes/consumer-goods.vue")
  },
  {
    name: "personal-group-printing",
    path: "/personal/group-printing",
    meta: indexFSTehX4z8sTT48wgUzfxiJGmKwne9hIoXno83bpYAJ4Meta || {},
    component: () => import("/var/www/2025-07-16_14_46/pages/personal/group-printing/index.vue")
  },
  {
    name: "personal-multi-delivery",
    path: "/personal/multi-delivery",
    meta: indexB_zl_45DQ8cigf9qow7uYzgo714id6zEUvDSINNx9tEbYMeta || {},
    component: () => import("/var/www/2025-07-16_14_46/pages/personal/multi-delivery/index.vue")
  },
  {
    name: "shippingtypes-medical-devices",
    path: "/shippingtypes/medical-devices",
    component: () => import("/var/www/2025-07-16_14_46/pages/shippingtypes/medical-devices.vue")
  },
  {
    name: "iframe-order-administer-guid",
    path: "/iframe/order/administer/:guid()",
    meta: _91guid_93Vr7vuhdrYkpjeO7byukZIxcNjaLDt10XsYPNk_c59XAMeta || {},
    component: () => import("/var/www/2025-07-16_14_46/pages/iframe/order/administer/[guid].vue")
  },
  {
    name: "personal-multi-delivery-guid",
    path: "/personal/multi-delivery/:guid",
    meta: _91guid_93qksLFxT9EIDQHfvnbhtxDn1UOIRKZeqSbKY3xeOS4XoMeta || {},
    component: () => import("/var/www/2025-07-16_14_46/pages/personal/multi-delivery/[guid].vue")
  },
  {
    name: "personal-order-template-id",
    path: "/personal/order/template/:id(.*)*",
    meta: _91_46_46_46id_93u_45Q5p9tS_45ktKPgvj_45xK_Jfdee4Gn08X_NWDK5C_45hshUMeta || {},
    component: () => import("/var/www/2025-07-16_14_46/pages/personal/order/template/[...id].vue")
  },
  {
    name: "shippingtypes-special-equipment",
    path: "/shippingtypes/special-equipment",
    component: () => import("/var/www/2025-07-16_14_46/pages/shippingtypes/special-equipment.vue")
  },
  {
    name: "shippingtypes-building-materials",
    path: "/shippingtypes/building-materials",
    component: () => import("/var/www/2025-07-16_14_46/pages/shippingtypes/building-materials.vue")
  },
  {
    name: "shippingtypes-musical-instruments",
    path: "/shippingtypes/musical-instruments",
    component: () => import("/var/www/2025-07-16_14_46/pages/shippingtypes/musical-instruments.vue")
  },
  {
    name: "shippingtypes-industrial-equipment",
    path: "/shippingtypes/industrial-equipment",
    component: () => import("/var/www/2025-07-16_14_46/pages/shippingtypes/industrial-equipment.vue")
  },
  {
    name: "shippingtypes-motorcycletransportation",
    path: "/shippingtypes/motorcycletransportation",
    component: () => import("/var/www/2025-07-16_14_46/pages/shippingtypes/motorcycletransportation.vue")
  },
  {
    name: "order-create-locationFrom_locationTo",
    path: "/order/create/:locationFrom()_:locationTo()",
    component: () => import("/var/www/2025-07-16_14_46/pages/order/create/[locationFrom]_[locationTo].vue")
  },
  {
    name: "shippingtypes-personalitemstransportation",
    path: "/shippingtypes/personalitemstransportation",
    component: () => import("/var/www/2025-07-16_14_46/pages/shippingtypes/personalitemstransportation.vue")
  }
]